import React, { createContext, useContext, useState } from "react";

export const MaterialPropertiesContext = createContext();

export const MaterialPropertiesProvider = ({ children }) => {
  const [tagCtlNoValue, setTagCtlNoValue] = useState();
  const [prsMdValue, setPrsMdValue] = useState();

  return (
    <MaterialPropertiesContext.Provider
      value={{
        tagCtlNoValue,
        setTagCtlNoValue,
        prsMdValue,
        setPrsMdValue,
      }}
    >
      {children}
    </MaterialPropertiesContext.Provider>
  );
};

export const useMaterialPropertiesContext = () => {
  return useContext(MaterialPropertiesContext);
};
